import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import jsonp from 'jsonp';
import _get from 'lodash.get';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';
import {
  insertAtIndexInArray,
  getSiteDomain,
  isTablet,
  isPrimeUser,
  // getParameterByName,
} from 'utils/common';
import { loginEventEmitter } from 'components/Login/Login';
import { openSidebar } from '../../reduxUtils/modules/comments';
// import { toggleNIC } from '../../routes/articleshow/redux';
import {
  getCommentsData,
  postComment,
  onFlagComment,
  getMoreComments,
  updateVoteCount,
  updateComments,
} from './redux';
import { toggleLoginBox } from '../../components/Login/redux';
import { disclaimer } from './constants';
import {
  getSortTypeData,
  config,
  RATE_TYPE,
  // getCommentsPostApi,
  getCommentsValidateApi,
  // getFlagApiData,
} from './config';
import CommentsNonPrime from './CommentsNonPrime';
import CommentsPrime from './CommentsPrime';
//import PrimeUserComments from './PrimeUserComments';
import { TOI_LIVE_DOMAIN } from '../../constants';
import {
  encodeDataForFormUrlEncodedRequest,
  saveRatingValidation,
  getSavedRatingValidation,
} from './utils';
import { isUserLoggedin } from './helpers';
import makeRequest from '../../utils/makeRequest';

const PrimeUserComments = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'withcomments' */ './PrimeUserComments'),
  loading: () => null,
  // timeout: 50000,
});

class WithComments extends React.Component {
  constructor() {
    super();
    this.state = {
      showVerificationMsg: false,
    };
    this.handleSort.bind(this);
    this.pageNum = 1;
    this.sortConfig = 'upvoted';
    this.isUserLoggedin = false;
  }

  componentDidMount() {
    this.loadComments();
  }

  componentDidUpdate(prevProps) {
    if (this.props.msid !== prevProps.msid) {
      this.sortConfig = 'upvoted';
      this.loadComments();
    }
  }

  loadComments() {
    let params = {
      msid: this.props.msid,
      pagenum: this.pageNum,
    };

    const defaultParams = this.getSortConfig(this.sortConfig);
    if (!defaultParams) {
      return;
    }

    params = { ...defaultParams, ...params };
    this.props.getCommentsData(params);
  }

  loadMoreComments = callback => {
    const pageNum = this.pageNum + 1;
    let params = {
      msid: this.props.msid,
      pagenum: pageNum,
    };

    const defaultParams = this.getSortConfig(this.sortConfig);
    this.pageNum = pageNum;
    if (!defaultParams) {
      return;
    }

    params = { ...defaultParams, ...params };
    this.props.getMoreComments(params, callback);
  };

  isValidRating(commentorId, voteType, voteCount, commentId) {
    const { userData = {} } = this.props;
    const { messages } = config;
    const loginStatus = isUserLoggedin(userData);
    let isValid = true;
    let errorMsg;
    const voteTypeData = WithComments.getVoteTypeId(voteType);
    const voteTypeUpperCase = voteType.toUpperCase();

    //check for same user
    const savedRating =
      getSavedRatingValidation(commentId, voteTypeData.id, 0) || {};
    let savedRatingType =
      WithComments.getVoteTypeId(savedRating.typeid || savedRating.offensiveId)
        .type || '';
    savedRatingType = savedRatingType.toUpperCase();

    const savedRatingOffensiveId = savedRating.offensiveId || '';
    let savedRatingOffensiveType =
      WithComments.getVoteTypeId(savedRatingOffensiveId).type || '';
    savedRatingOffensiveType = savedRatingOffensiveType.toUpperCase();

    if (loginStatus && commentorId === userData.getId()) {
      isValid = false;
      switch (voteTypeUpperCase) {
        case RATE_TYPE.AGREED:
          errorMsg = messages.self_agree;
          break;
        case RATE_TYPE.DISAGREED:
          errorMsg = messages.self_disagree;
          break;
        case RATE_TYPE.OFFENSIVE:
          errorMsg = messages.self_offensive;
          break;
        default:
          break;
      }
    } else if (
      savedRating.count &&
      savedRating.count > 0 &&
      (voteTypeUpperCase === savedRatingType ||
        voteTypeUpperCase === savedRatingOffensiveType)
    ) {
      isValid = false;
      switch (voteTypeUpperCase) {
        case RATE_TYPE.AGREED:
          errorMsg = messages.already_agree;
          break;
        case RATE_TYPE.DISAGREED:
          errorMsg = messages.already_disagree;
          break;
        case RATE_TYPE.OFFENSIVE:
          errorMsg = messages.already_offensive;
          break;
        default:
          break;
      }
    } else if (savedRating.count && savedRating.count > 0) {
      if (
        savedRatingType === RATE_TYPE.AGREED &&
        voteTypeUpperCase === RATE_TYPE.DISAGREED
      ) {
        isValid = false;
        errorMsg = messages.cant_agree_disagree;
      } else if (
        savedRatingType === RATE_TYPE.DISAGREED &&
        voteTypeUpperCase === RATE_TYPE.AGREED
      ) {
        isValid = false;
        errorMsg = messages.cant_agree_disagree;
      } else if (
        savedRatingType === RATE_TYPE.AGREED &&
        voteTypeUpperCase === RATE_TYPE.OFFENSIVE
      ) {
        isValid = false;
        errorMsg = messages.cant_agree_offensive;
      } else if (
        savedRatingOffensiveType === RATE_TYPE.OFFENSIVE &&
        voteTypeUpperCase === RATE_TYPE.AGREED
      ) {
        isValid = false;
        errorMsg = messages.cant_agree_offensive;
      }
    }

    return {
      isValid,
      errorMsg,
    };
  }

  static getVoteTypeId(voteType) {
    let voteTypeData = {};
    if (voteType === 'AGREED' || parseInt(voteType, 10) === 100) {
      voteTypeData = {
        type: 'Agreed',
        id: '100',
      };
    } else if (voteType === 'DISAGREED' || parseInt(voteType, 10) === 101) {
      voteTypeData = {
        type: 'Disagreed',
        id: '101',
      };
    } else if (parseInt(voteType, 10) === 103 || voteType === 'OFFENSIVE') {
      voteTypeData = {
        type: 'OFFENSIVE',
        id: '103',
      };
    }

    return voteTypeData;
  }

  putVote = (commentId, voteType, voteCount, msid) => {
    const voteTypeData = WithComments.getVoteTypeId(voteType);
    let url = 'https://myt.indiatimes.com/mytimes/addActivity';

    const data = {
      appKey: 'TOI',
      parentCommentId: commentId,
      activityType: voteTypeData.type,
      baseEntityType: 'ARTICLE',
      objectType: 'A',
      url: window.location.href,
    };

    url += `?${encodeDataForFormUrlEncodedRequest(data)}`;
    const callback = () => {
      saveRatingValidation(commentId, voteTypeData.id, 0, voteCount);
      this.props.updateVoteCount({ msid, commentId, voteType, voteCount });
    };
    jsonp(url, null, callback);
    this.rateComment(commentId, voteTypeData.id);
  };

  createCommentObjectFromData(commentData) {
    const { userData = {} } = this.props;

    const commentObj = {
      _id: Date.now(),
      F_NAME: commentData.fromname,
      CITY: commentData.location,
      C_D: Date.now(),
      addedNow: 1,
      C_T: commentData.message,
      AC_A_C: 0,
      AC_D_C: 0,
    };

    if (userData.isLoggedIn && userData.getId()) {
      commentObj.A_ID = userData.getId();
      commentObj.user_detail = commentObj.user_detail || {};
      commentObj.user_detail.thumb = userData.getThumb() || '';
      commentObj.user_detail.U_P_S = isPrimeUser();
    }

    return commentObj;
  }

  findParentCommentInData(data, id) {
    let parentComment;

    for (let i = 0; i < data.length; i += 1) {
      if (!data[i]._id) {
        // continue;
      } else if (data[i]._id === id) {
        parentComment = data[i];
        break;
      } else if (data[i].CHILD && data[i].CHILD.length) {
        parentComment = this.findParentCommentInData(data[i].CHILD, id);
        if (parentComment) {
          break;
        }
      }
    }

    return parentComment;
  }

  handlePostCommentResponse(responseBody, commentData) {
    const response = responseBody.data ? responseBody.data.toLowerCase() : '';
    const { userData } = this.props;
    const isLoggedIn =
      userData && typeof userData.getUid === 'function' && userData.getUid();
    if (response === 'duplicatecontent') {
      //ideally should show error
      //but curently in Prod, not showing error, check with Product
    }

    if (isLoggedIn) {
      this.addCommentToState(commentData);
      this.setState({ showVerificationMsg: false });
    } else {
      this.setState({ showVerificationMsg: true });
    }
  }

  getComments = () => {
    const data =
      this.props.comments && this.props.comments.commentsData
        ? this.props.comments[`commentsData-${this.props.msid}`]
        : [];
    return data;
  };

  addCommentToState(commentData) {
    const commentObj = this.createCommentObjectFromData(commentData);
    const updatedData = Object.assign([], this.getComments());
    const { parentid } = commentData;
    let parentComment;

    if (parseInt(parentid, 10) === 0) {
      //has no parent
      //updatedData.unshift(commentObj);
      insertAtIndexInArray(updatedData, 1, commentObj);
      updatedData[0].totalcount += 1;
    } else {
      //updatedData.
      parentComment = this.findParentCommentInData(updatedData, parentid);
      if (!parentComment.CHILD) {
        parentComment.CHILD = [];
      }
      //parentComment['CHILD'].unshift(commentObj);
      insertAtIndexInArray(parentComment.CHILD, 1, commentObj);
    }
    // this.setState({
    //   data: updatedData,
    // });

    this.props.updateComments({
      msid: this.props.msid,
      comments: [...updatedData],
    });
  }

  validateComment(commentData, callback) {
    const domain = getSiteDomain();
    const endpoint = domain + getCommentsValidateApi().endpoint;
    const { params } = getCommentsValidateApi();
    const data = { ...params, ...commentData };
    axios
      .post(endpoint, data)
      .then(response => {
        //console.log('validate success ', data.data);
        if (response.data === 'duplicatecontent') {
          //callback(config.messages.duplicate);
        } else if (response.data === 'abusivecontent') {
          //callback(config.messages.abusive);
        } else {
          callback.call(this, null);
        }
      })
      .catch();
  }

  handleAddComment = (commentData, nonLoggedInUserObj) => {
    /*
     * Pick data from Login
     * module, once module dev done
     */
    const { userData } = this.props;
    const isLoggedIn =
      userData && typeof userData.getUid === 'function' && userData.getUid();
    let userObj = {};

    if (nonLoggedInUserObj) {
      userObj = {
        fromname: nonLoggedInUserObj.name,
        fromaddress: nonLoggedInUserObj.email,
        userid: '',
        location: nonLoggedInUserObj.loc,
        imageurl: '',
      };
    } else {
      userObj = {
        fromname: `${userData.getFirstName()} ${
          typeof userData.getLastName === 'function' && userData.getLastName()
            ? userData.getLastName()
            : ''
        }`,
        fromaddress: userData.getEmail(),
        userid: userData.getUid(),
        location: userData.getCITY(),
        imageurl: userData.getIcon(),
      };
    }

    const userDetailParam = {
      ...userObj,
      loggedstatus: isLoggedIn ? 1 : 0,
      roaltdetails: 1,
      configid: 41083278,
      urs: '',
      rotype: 0,
    };
    const additionalData = {
      //url = window.location.href
      url: TOI_LIVE_DOMAIN + window.location.pathname,
    };
    const newCommentData = {
      ...userDetailParam,
      ...commentData,
      ...additionalData,
    };

    if (!isLoggedIn) {
      newCommentData.verifyuser = 1;
    }

    this.validateComment(newCommentData, () => {
      if (config.sendCommentLiveEmail) {
        /*
						msgObj.verifyuser = 1;
						api.postCommentWithoutVerification(msgObj, function(response) {
							event.publish("comment.post.posted");
							if (callback) {
								callback(commentObj)
							}
						})
					*/
        //modify commentData
      } else {
        /*
						check with Bharat, why need these conditions
						enableparam & rotype have been defined in AS js code
						if (tthis.config.enableparam && msgObj.rotype != 0) {
						    msgObj.configid = "46516605"
						} else {
						    if (msgObj.rotype != 0) {
						        msgObj.url = msgObj.url + "?"
						    }
						}
					*/
        //modify commentData
      }
      /*
-   * get pcode from user login,
-   * times point tp channel
-   */
      newCommentData.pcode = 'TOI';
      this.props.postComment(
        newCommentData,
        this.handlePostCommentResponse.bind(this),
      );
    });
  };

  getSortConfig = sortType => {
    const sortData = getSortTypeData();
    const sortTypeConfig = sortData.filter(item => item.label === sortType);
    this.sortConfig = sortType;
    this.pageNum = 1;
    if (!sortTypeConfig.length) {
      return undefined;
    }

    return sortTypeConfig[0].queryParams;
  };

  handleSort(apiParams, callback) {
    const params = {
      ...apiParams,
      ...{ msid: this.props.msid, pagenum: this.pageNum },
    };
    this.props.getCommentsData(params, callback);
  }

  onSortClick = (sortType, callback) => {
    const sortTypeConfig = this.getSortConfig(sortType);
    if (sortTypeConfig) {
      this.handleSort(sortTypeConfig, callback);
    }
  };

  openSidebar = msid => {
    this.props.openSidebar(msid);
    // this.props.toggleNIC(false);
  };

  onFlagComment = (data, callback) => {
    this.props.onFlagComment(data, callback);
    this.rateComment(data.ofcommenteroid, 103);
  };

  rateComment = (id, typeid) => {
    makeRequest.get(
      `/ratecomment_new.cms?opinionid=${id}&typeid=${typeid}&rateid=0`,
      {},
      'skipfeedengine',
    );
  };

  showLoginBox = isOpen => {
    if (isOpen) {
      loginEventEmitter(
        () => {
          // send login success from blocker GA
          // analyticsWrapper(
          //   'gaAndGrx',
          //   'send',
          //   'event',
          //   window.categoryForGA,
          //   'Nonprime-login_blocker|Login_Success',
          //   gaLabel,
          // );
          // this.showBlockerScreenWelcomeMsg();
        },
        {
          callOneTapSignOnPriority: true,
          // callOneTapSignOnPriority: getParameterByName('onetap') === '1',
          source: `comment_${
            window.location.href.indexOf('/articleshow/') !== -1 ? 'AS' : 'LB'
          }`,
        },
      );
    } else {
      this.props.toggleLoginBox(isOpen);
    }
  };

  render() {
    const { query } = this.props;
    let Comment = CommentsNonPrime;
    if (this.props.isPrimeUserLayout) {
      Comment = PrimeUserComments;
    } else if (this.props.toipLayout) {
      Comment = CommentsPrime;
    }
    const tablet = isTablet();
    if (this.props.commentModeration === '3.0') {
      return null;
    }

    return (
      <Comment
        msid={this.props.msid}
        commentsData={this.getComments()}
        handleAddComment={this.handleAddComment}
        disclaimer={disclaimer}
        getSortTypeData={getSortTypeData}
        userData={this.props.userData}
        toggleLoginBox={this.showLoginBox}
        onSortClick={this.onSortClick}
        onFlagComment={this.onFlagComment}
        putVote={this.putVote}
        isValidRating={(commentorId, voteType, voteCount, commentId) =>
          this.isValidRating(commentorId, voteType, voteCount, commentId)
        }
        config={config}
        isUserLoggedin={isUserLoggedin}
        isTimelineVisible={this.props.isTimelineVisible}
        postCommentText={this.props.postCommentText}
        readCommentsTxt={this.props.readCommentsTxt}
        // showTopComment={this.props.showTopComment}
        redirectBtnClick={this.props.redirectBtnClick}
        isWapView={this.props.isWapView}
        openSidebar={this.openSidebar}
        sidebarOpenMsid={this.props.sidebarOpenMsid}
        loadMoreComments={this.loadMoreComments}
        isPrime={this.props.isPrime}
        isTablet={tablet}
        commentTextInputRef={this.props.commentTextInputRef}
        showVerificationMsg={this.state.showVerificationMsg}
        seoData={this.props.seoData}
        commentIdHighlighted={this.props.commentIdHighlighted}
        hideBottomComments={this.props.hideBottomComments}
        followees={this.props.followees}
        isPrivateUser={this.props.isPrivateUser}
        commentModeration={this.props.commentModeration}
        showBottomCommentsV2={this.props.showBottomCommentsV2}
        isGrid2Col={this.props.isGrid2Col}
        query={query}
        isSidebarPortable={this.props.isSidebarPortable}
        isSidebarPortablev2={this.props.isSidebarPortablev2}
        loadCommentsSidebarOutside={this.props.loadCommentsSidebarOutside}
        toipLayout={this.props.toipLayout || this.props.isPrimeUserLayout}
        openSidebarCallback={this.props.openSidebarCallback}
      />
    );
  }
}

const mapStateToProps = state => ({
  comments: state.comments,
  userData: _get(state, 'login.userData', {}),
  sidebarOpenMsid: state.commentscommon.sidebarOpen,
  isPrime: state.isPrime,
  commentIdHighlighted: state.commentscommon.commentIdHighlighted,
  followees: state.comments.followees,
  isPrivateUser: state.gdpr.isPrivateUser,
  hasFolloweesData: state.comments.hasFolloweesData,
});

const mapDispatchToProps = dispatch => ({
  getCommentsData: (params, callback) => {
    dispatch(getCommentsData(params, callback));
  },
  getMoreComments: (params, callback) => {
    dispatch(getMoreComments(params, callback));
  },
  postComment: (params, callback) => {
    dispatch(postComment(params, callback));
  },
  toggleLoginBox: isOpen => {
    dispatch(toggleLoginBox(isOpen));
  },
  onFlagComment: (params, callback) => {
    dispatch(onFlagComment(params, callback));
  },
  openSidebar: msid => {
    dispatch(openSidebar(msid));
  },
  updateVoteCount: params => {
    dispatch(updateVoteCount(params));
  },
  updateComments: params => {
    dispatch(updateComments(params));
  },
  // toggleNIC: isOpen => {
  //   dispatch(toggleNIC(isOpen));
  // },
});

WithComments.propTypes = {
  msid: PropTypes.string.isRequired,
  userData: PropTypes.shape({}),
  comments: PropTypes.shape({
    commentsData: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  onFlagComment: PropTypes.func.isRequired,
  toggleLoginBox: PropTypes.func.isRequired,
  isTimelineVisible: PropTypes.bool,
  postComment: PropTypes.func.isRequired,
  getCommentsData: PropTypes.func.isRequired,
  postCommentText: PropTypes.string,
  readCommentsTxt: PropTypes.string,
  getMoreComments: PropTypes.func.isRequired,
  // showTopComment: PropTypes.bool,
  redirectBtnClick: PropTypes.bool,
  isWapView: PropTypes.bool,
  openSidebar: PropTypes.func.isRequired,
  sidebarOpenMsid: PropTypes.string,
  isPrime: PropTypes.bool,
  toipLayout: PropTypes.bool,
  isPrimeUserLayout: PropTypes.bool,
  updateVoteCount: PropTypes.func.isRequired,
  updateComments: PropTypes.func.isRequired,
  commentTextInputRef: PropTypes.shape({}),
  // toggleNIC: PropTypes.func,
  seoData: PropTypes.shape({}),
  commentIdHighlighted: PropTypes.number,
  hideBottomComments: PropTypes.bool,
  followees: PropTypes.arrayOf(PropTypes.number),
  isPrivateUser: PropTypes.bool,
  commentModeration: PropTypes.string,
  showBottomCommentsV2: PropTypes.bool,
  isGrid2Col: PropTypes.bool,
  isSidebarPortable: PropTypes.bool,
  isSidebarPortablev2: PropTypes.bool,
  loadCommentsSidebarOutside: PropTypes.func,
};

WithComments.defaultProps = {
  userData: undefined,
  comments: undefined,
  isTimelineVisible: false,
  postCommentText: undefined,
  readCommentsTxt: undefined,
  sidebarOpenMsid: '',
  // showTopComment: false,
  redirectBtnClick: false,
  isWapView: false,
  isPrime: false,
  toipLayout: false,
  commentTextInputRef: React.createRef(),
  // toggleNIC: () => {},
  seoData: {},
  commentIdHighlighted: -1,
  hideBottomComments: false,
  followees: [],
  isPrivateUser: true,
  commentModeration: '',
  showBottomCommentsV2: false,
  isGrid2Col: false,
  isSidebarPortable: false,
  isSidebarPortablev2: false,
  loadCommentsSidebarOutside: () => null,
  isPrimeUserLayout: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithComments);
